import { render } from "./Footer.vue?vue&type=template&id=4c671c5b&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=4c671c5b&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c671c5b"]])

export default __exports__